import { prefetch } from '../asset-prefetcher';

export async function runPrefetchAssetImplementation(data: { asset?: { url?: string } }) {
  const url = data?.asset?.url;
  if (!url) {
    throw new Error('Prefetch asset: missing asset url');
  }
  await prefetch(url);
}
